import { urlConstants } from 'common/utils/constants';

import { secureApi } from '../api/Axios';

export const getInvestorAllDeals = () =>
  secureApi.get(urlConstants.getInvestorAllDeals);

export const getInvestorDealById = (payload: any) =>
  payload.id
    ? secureApi.get(`${urlConstants.getInvestorDealById}?id=${payload.id}`)
    : secureApi.get(
        `${urlConstants.getInvestorDealById}?dealName=${payload.dealName}`,
      );

export const getDealUpdates = (dealId: string) =>
  secureApi.get(`${urlConstants.getDealUpdates}?id=${dealId}`);
